import React from 'react';
import Reveal from 'react-awesome-reveal';

// Import Custom Component
import ALink from '../../common/ALink';

// Import Settings
import { fadeIn } from '../../../utils/data/keyframes';
import { LazyLoadImage } from 'react-lazy-load-image-component';

const NO_ELECTRONICS = process.env.NEXT_PUBLIC_NO_ELECTRONICS === 'true';

function SaleBanner() {
  return (
    <div className="sale-banner banner banner-auto-height">
      <div className="banner-content">
        <Reveal delay={100} duration={1500} keyframes={fadeIn} triggerOnce>
          <div className="row no-gutter d-flex justify-content-center">
            {NO_ELECTRONICS
              ? <>
                    <div className="d-flex flex-column justify-content-center">
                        <div className="banner-text-title">Your ideal furniture</div>
                        <h4 className="banner-text-content">Transform your space with the perfect furniture, delivered directly to your home.</h4>
                    </div>
                    <div className="">
                        <LazyLoadImage
                            alt="no-electronics-banner"
                            src="/images/banners/banner.png"
                            threshold={500}
                            effect="black and white"
                        />
                    </div>
                </>
                : <>
                  <div className="d-flex flex-column justify-content-center">
                    <h4 className="text-uppercase mb-0">Perfect appliances at the</h4>
                    <h4 className="mb-0 text-uppercase bigger">Electronics Store</h4>
                    <div className="mb-0 btn-shop">
                      <ALink
                        className="btn-lg btn btn-blue"
                        href={process.env.ELECTRONICS_URL}>
                        VISIT STORE
                      </ALink>
                    </div>
                  </div>
                  <div className="">
                    <LazyLoadImage
                      className="sale-img"
                      alt="banner"
                      src="/images/electronics-img.png"
                      threshold={500}
                      effect="black and white"
                    />
                  </div>
                </>
            }
          </div>
        </Reveal>
      </div>
    </div>
  );
}

export default React.memo(SaleBanner);
